import React, { useState, useEffect, useRef } from "react";
import tagIcon from "../../assets/img/tag.svg";
import Translations from "../../services/translation.service";
import OfferCard from "./offer-card.js";
import OfferActiveCard from "./offer-active-card.js";
import Settings from '../../services/settings.service';
import SpinnerTimeLoader from "./timeLoading";

const subscriptions = [];
const prefix = "scr_3810_P_";
const offersPrefix = "stm_offer_popup_";
const OffersPopup = ({
  toggleOffersModal,
  activeOffers,
  isError,
  unGroupedOffers,
  appliedOffer = {},
  offersList = {},
  promoCode,
  selectedCard,
  handleApply,
  fetchOffers,
  modalLoader,
  setError,
  setPromoCode,
  setAppliedOffer
}) => {

  let legal_link = Settings.legal_link;
  legal_link = legal_link?.replace("%lang%", Translations.activeLang);

  const [isInputPromo, setInputPromo] = useState(false);
  const inputRef = useRef();
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );

  useEffect(() => {
    document.body.classList.add("disable-scroll");
    return () => {
      document.body.classList.remove("disable-scroll");
    };
  }, []);

  const handlePromoCode = (e) => {
    setError(false);
    setPromoCode(e.target.value);
  };

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );
    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);


  return (
    <div className="offers-modal-overlay">
      <div className="offers-modal-container">
        <div className="header-section">
          <div className="header-text">
            <p className="header">{translationKeys[offersPrefix + "header"]}</p>
          </div>
          <button onClick={toggleOffersModal}>{translationKeys[offersPrefix + "done"]}</button>
        </div>
        {modalLoader ? (
          <SpinnerTimeLoader />
        ) : (
          <>
            <div className="group-container">
              {Object.keys(offersList).map((key, index) => (
                <div key={index}>
                  <div className="header-section">
                    <div className="header-text">
                      <p className="desciption">
                        {translationKeys[offersPrefix + "desc"]}
                      </p>
                      <p className="desciption">
                        {translationKeys[offersPrefix + "check"]} <span>
                          <a href={legal_link} target="_blank" rel="noopener noreferrer">
                            {translationKeys[offersPrefix + "terms"]}
                          </a>
                        </span>
                      </p>
                    </div>
                  </div>
                  {offersList[key].map((offer) => (
                    <OfferCard
                      appliedOffer={appliedOffer}
                      selectedCard={selectedCard}
                      objKey={key}
                      offer={offer}
                      fetchOffers={fetchOffers}
                      prefix={prefix}
                      translationKeys={translationKeys}
                      setAppliedOffer={setAppliedOffer}
                    />
                  ))}
                </div>
              ))}
            </div>
            <div
              className={`promo-code-container ${isError && "error"}`}
              onBlur={() => {
                setInputPromo(false);
              }}
              onClick={() => {
                inputRef.current.focus();
                setInputPromo(true)
              }}
            >
              <img src={tagIcon} alt="tagIcon" />
              {!isInputPromo && !promoCode && (
                <p className="promo-code">{translationKeys[offersPrefix + "promo_code"]}</p>
              )}
              <input ref={inputRef} type="text" value={promoCode} onChange={handlePromoCode} />
              {promoCode && (
                <button
                  className={`apply-button ${isError ? "" : "apply"}`}
                  disabled={isError}
                  onClick={handleApply}
                >
                  {translationKeys[offersPrefix + "apply"]}
                </button>
              )}
            </div>
            {isError && <p className="error">{translationKeys[offersPrefix + "invalid"]}</p>}
            {activeOffers.map((offer) => (
              <OfferActiveCard
                offer={offer}
                prefix={prefix}
                translationKeys={translationKeys}
              />
            ))}
            {unGroupedOffers.map((offer) => (
              <OfferCard
                selectedCard={selectedCard}
                offer={offer}
                prefix={prefix}
                fetchOffers={fetchOffers}
                translationKeys={translationKeys}
                setAppliedOffer={setAppliedOffer}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default OffersPopup;
